module.exports = __webpack_public_path__ + "static/media/battle.0d98424b.mp3";